// extracted by extract-css-chunks-webpack-plugin
module.exports = {"catalog-grid":"catalog-grid___1dHTq","card":"card___fGCf_"};